import React, { Component } from 'react';
import { connect, } from 'react-redux';
import { CloseButton, Container, Modal, Spinner, Carousel, } from 'react-bootstrap';
import { withRouter } from './withRouter';
import PageSEO from 'components/Utlility/PageSEO';
import { getGameSeoOverrides } from 'constants/SeoConfig';
import Lottie from 'react-lottie';
import ReactPlayer from 'react-player';
import Analytics from "analytics";

import { getGameList, findGameById, findGameBySlug } from "constants/GameListAdapter";
import styles from './ShopGamePackStyles.module.scss';
import Game from './Games/Game';
import { addToCart } from 'actions/cart';

import DotLoader from 'components/Utlility/DotLoader';


import time from 'animations/time-black.png'
import players from 'animations/minPlayers-black.png'

import age6Black from "animations/ageRatings/age-6.png";
import age8Black from "animations/ageRatings/age-8.png";
import age10Black from "animations/ageRatings/age-10.png";
import age12Black from "animations/ageRatings/age-12.png";
import age14Black from "animations/ageRatings/age-14.png";

import GiftBox from "images/Promotions/02642 Christmas Present.png";

import StarFull from "images/template/full-star.png";
import StarEmpty from "images/template/empty-star.png";
import TrustBoxContainer, { TRUSTPILOT_TEMPLATES } from './TrustWidget';
import VideoThumbnail from "videos/video-thumbnail.png";
import { Link } from 'react-router-dom';
import PricingFunctions from '../common/PricingFunctions';

import { APP_TYPES } from "constants/AppTypes";
import WebIcon from "images/icons/web-icon.png";
import FireTVIcon from "images/icons/FireTV-Icon.png";
import RokuIcon from "images/icons/Roku-Icon-v2.png";
import placeHolderDesktop from 'images/gameStorePreviews/placeholder-desktop.svg';
import placeHolderMobile from 'images/gameStorePreviews/placeholder-mobile.svg';
import placeHolderLogo from 'images/gameLogos/placeholder-logo.svg';
import placeHolderBackground from 'images/storeBackgrounds/placeholder-background.svg';

const howItWorksBlocks = [
    {
        number: 1,
        title: "GET IT ON THE BIG SCREEN",
        //"description": "Only one person needs to own the games. They will be 'party leader' and it's their job to get Game.City up on the biggest screen they can. Use Teams, Zoom or Discord if you want to play online. Use a smart TV to open it with a browser or connect up with a laptop and HDMI. Once you have achieved that, simply log in to your account."
        "description": "Open Game.City on Fire TV, Roku, smart TV, or laptop and log in!"
    },
    {
        number: 2,
        title: "GATHER SOME FRIENDS",
        //description: "Gather some friends, either online or in the same room. Once you have Game.City on the screen and you're logged in, players simply need to scan the QR code to join in, or head to Game.City and join using the Room Code.",
        description: "Scan the QR code or enter the Room Code at Game.City.",
    },
    {
        number: 3,
        title: "PLAY AND HAVE FUN",
        //description: "Once joined, choose a potato avatar, change your nickname and then choose a game. Get playing and have a great time. All our online games are extra family friendly so everyone can enjoy!"
        description: "Choose an avatar, pick a game, and enjoy"
    }
];

class ShopGamePack extends Component {
    static displayName = ShopGamePack.name;

    constructor(props) {
        super(props);

        this.state = {
            // game: {},
            showHowToPlay: false,
        };
    }

    /**
     * Get the game pack object - either from props or by looking up from URL slug.
     * This handles the case where routes are defined before games are loaded from API.
     */
    getGame() {
        // If game prop exists, use it
        if (this.props.game) {
            return this.props.game;
        }
        // Otherwise, look up by URL slug (games loaded async from API)
        return findGameBySlug(this.props.location.pathname);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        const game = this.getGame();
        if (game) {
            Analytics.viewContent(game.productId);
        }
    }

    componentDidUpdate(prevProps) {
        // Re-initialize if game wasn't loaded before but is now
        const game = this.getGame();
        const prevGame = prevProps.game || findGameBySlug(prevProps.location?.pathname);
        if (!prevGame && game) {
            Analytics.viewContent(game.productId);
        }
    }

    getStoreAccentBorder() {
        return {
            backgroundColor: this.getGame()?.meta.storeAccentColour,
            border: `10px solid ${this.getGame()?.meta.storeAccentColour}`
        }
    }

    getStoreAccentBackground() {
        return {
            backgroundColor: this.getGame()?.meta.storeAccentColour,
            border: `10px solid ${this.getGame()?.meta.storeAccentColour}`
        }
    }

    getStoreAccentImageBorder() {
        return {
            border: `2px solid ${this.getGame()?.meta.storeAccentColour}`
        }
    }

    getStoreBackground() {
        const bg = this.getGame()?.meta?.storeBackground || placeHolderBackground;
        return {
            backgroundImage: `url(${bg})`
        }
    }

    getStoreInfoBackground() {
        return {
            backgroundColor: `${this.getGame()?.meta.storeInfoBackground}`
        }
    }

    addGameToCart(game) {
        this.props.addToCart(game);
    }

    getIncludedGames = () => {
        let includedGames = getGameList().filter((x) => this.getGame()?.gamePackInfo.gamesIncluded.find((y) => y.gameId === x.gameId));

        return includedGames
    }

    getMobileMobileImages = () => {
        const groupSize = 2;
        let arr = [];
        for (let i = 0; i < this.getGame()?.gamePackInfo.gamesIncluded.length; i += groupSize) {
            const group = this.getGame()?.gamePackInfo.gamesIncluded.slice(i, i + groupSize);

            arr.push(<div className={`${styles.imageRow} ${styles.doubleColRow}`}>
                {
                    group.map((g) => {
                        return <div style={this.getStoreAccentImageBorder()}>
                            <img src={g.mobile1}></img>
                        </div>
                    })
                }
            </div>);
        }

        return arr;
    }

    getPrice() {
        let countryCode = this.props.pricing.countryCode;
        let pricing = PricingFunctions.getEffectiveGamePricing(countryCode, this.getGame());
        return pricing.display;
    }

    getStrikethroughPrice = () => {
        let games = this.getIncludedGames();
        let price = 0;
        let currency;
        let currencyCode = this.props.pricing.countryCode;
        games.forEach((g) => {
            let gamePrice = currencyCode == "GB" ? g.pricing.gb : g.pricing.us;
            if (gamePrice) {
                price += gamePrice.raw;
                currency = gamePrice.display.slice(0, 1);
            }
        });
        if (price === 0) {
            return null;
        }
        return currency + price;
    }

    getStars() {
        let stars = [];
        for (let i = 0; i < this.getGame()?.gamePackInfo.stars; i++) {
            stars.push(<img className={styles.star} src={StarFull} alt="Star" />)
        }
        for (let i = 0; i < 5 - this.getGame()?.gamePackInfo.stars; i++) {
            stars.push(<img className={styles.star} src={StarEmpty} alt="Star" />)
        }
        return stars;
    }

    closeHelpModal = () => {
        this.setState({ showHowToPlay: false, });
    }

    getPackHero = () => {
        return {
            backgroundImage: `url(${this.getGame()?.meta.packHero})`
        }
    }

    newLineText = (text) => {
        return text.split('\n').map((str) => {
            return <>{str}<br /></>
        });
    }

    scrollIntoView = (id) => {
        document.getElementById(id).scrollIntoView({ behavior: "smooth" });
    }

    getAgeIcon() {
        switch (this.getGame()?.gamePackInfo.minAge) {
            case 6:
                return age6Black;
            case 8:
                return age8Black;
            case 10:
                return age10Black;
            case 12:
                return age12Black;
            case 14:
                return age14Black;
            default:
                return age8Black;
        }
    }

    getSupportedPlatforms() {
        if (!this.getGame()) return;

        let platforms = [];
        for (let i = 0; i < this.getGame().supportedPlatforms.length; i++) {
            let platform = this.getGame().supportedPlatforms[i];
            let img = null;
            let link = null;

            switch (platform) {
                case APP_TYPES.WEB:
                    img = WebIcon;
                    break;
                case APP_TYPES.FIRE_TV:
                    img = FireTVIcon;
                    link = "https://www.amazon.co.uk/Game-City-Game-City/dp/B0FCYQ3QY7/ref=sr_1_6?crid=1HYZ8KROZPE3Q&dib=eyJ2IjoiMSJ9.8FmPt9aRPWTU9EIjS4v9rBc1OzkR5g7FwwI6Bts_C4nD1Hos0s_FKTAEzgkEW5MWoFy-Z7AN9cDeW70SMLQ_JiDh_WU6x3PrH2CxLSmUbHPBgWA-UszU3foPJtC0pK2aseieTBMCVzwS2Ez2UeKVh-cjY5p_0E_fqYRG4qAfYscIMoOKn-1jKWxS-RpyIw9lgpr8JUMQaSZyq_COX2MO3SKsoyShTzZONoktuJoNTJkVJ2fcS4g_iGAU5y-Qy8g45K9Cah0IEH2EkelWFkIHmt6SKaU8FDTL3FTD90uElsk.DYEAaB96KVfdhfMuXvjklBo42TKSgftMh4AT_oE44mU&dib_tag=se&keywords=Game+City&qid=1756198594&sprefix=game+city%2Caps%2C104&sr=8-6";
                    break;
                case APP_TYPES.ROKU:
                    img = RokuIcon;
                    link = "https://channelstore.roku.com/en-gb/details/f40f6c4e12bfb9b619aa4530404178ea:bf00789f9ba54a68d7fc648d46ddbfc5/game-city-party-games-on-tv";
                    break;
                default:
                    break;
            }

            if (img != null) {
                if (link != null) {
                    platforms.push(
                        <div className={styles.platform}>
                            <a href={link} target="_blank">
                                <img src={img} />
                            </a>
                        </div>
                    )
                } else {
                    platforms.push(
                        <div className={styles.platform}>
                            <img src={img} />
                        </div>
                    )
                }
            }
        }

        return platforms;
    }


    render() {
        return (
            <React.Fragment>
                {(() => {
                    const game = this.getGame();
                    const seoOverrides = getGameSeoOverrides(game?.storeSlug);
                    const title = seoOverrides?.title || `Play ${game?.name} on Your TV | Game.city`;
                    const description = seoOverrides?.description || game?.description;
                    const canonical = `https://game.city${game?.storeSlug}`;
                    return <PageSEO title={title} description={description} canonical={canonical} robots="index, follow" />;
                })()}
                <div className={styles.pageShopSingle} style={this.getStoreBackground()}>
                    <section className={`${styles.band} ${styles.noTop}`}>
                        <Container className="text-center">
                            <div className='row'>
                                <Carousel className={styles.hero} controls={false}>
                                    {
                                        this.getGame()?.meta.heros.map((h) => {
                                            return <Carousel.Item className={styles.carouselItem}>
                                                <img src={h} alt="Hero" className={styles.carouselImage} />
                                            </Carousel.Item>
                                        })
                                    }
                                </Carousel>
                            </div>
                            <div className='row text-center mt-3'>
                                <h1 className='text-uppercase mb-0'>{getGameSeoOverrides(this.getGame()?.storeSlug)?.h1 || this.newLineText(this.getGame().gamePackInfo.title)}</h1>
                                <p style={{ color: "white", fontSize: "20px" }}>{this.getGame().gamePackInfo.subTitle}</p>
                            </div>
                            <div className={`row justify-content-center ${styles.gameInfoContainer}`}>
                                {/*<div className='col-lg-8 order-2 order-lg-1 text-center'>*/}
                                {/*    <div className={`${styles.previewImages} d-none d-lg-block`} style={{ ...this.getStoreAccentBorder(), ...this.getStoreAccentBackground() }}>*/}
                                {/*        {*/}
                                {/*            this.getGame().gamePackInfo?.gamesIncluded.map((g, i) => {*/}
                                {/*                return <div className={`${styles.imageRow} ${i % 2 == 0 && styles.reverse}`}>*/}
                                {/*                    <div style={this.getStoreAccentImageBorder()}>*/}
                                {/*                        <img className={styles.mobilePreview} src={g.mobile1}></img>*/}
                                {/*                    </div>*/}
                                {/*                    <div style={this.getStoreAccentImageBorder()}>*/}
                                {/*                        <img className={styles.desktopPreview} src={g.desktop1}></img>*/}
                                {/*                    </div>*/}
                                {/*                </div>*/}
                                {/*            })*/}
                                {/*        }*/}
                                {/*    </div>*/}
                                {/*    <div className={`${styles.previewImages} ${styles.mobile} d-block d-lg-none`} style={this.getStoreAccentBorder()}>*/}
                                {/*        {*/}
                                {/*            this.getGame().gamePackInfo?.gamesIncluded.map((g, i) => {*/}
                                {/*                return <div className={`${styles.imageRow} ${styles.singleDesktopRow}`}>*/}
                                {/*                    <div style={this.getStoreAccentImageBorder()}>*/}
                                {/*                        <img src={g.desktop1}></img>*/}
                                {/*                    </div>*/}
                                {/*                </div>*/}
                                {/*            })*/}
                                {/*        }*/}
                                {/*        {*/}
                                {/*            this.getMobileMobileImages()*/}
                                {/*        }*/}
                                {/*    </div>*/}
                                {/*</div>*/}
                                <div className={`${styles.gamesList} col-xl-4 col-lg-5 col-md-6`}>
                                    {
                                        this.getGame()?.gamePackInfo.gamesIncluded.map((g) => {
                                            // Store context: use storeTinyCard only - no fallback
                                            return <img src={g.storeTinyCard} alt={`${g.name}`} onClick={() => this.props.navigate(g.storeSlug)} className={styles.tinyCard} />
                                        })
                                    }
                                </div>
                                <div className='col-xl-4 col-lg-5 col-md-6 order-1 order-lg-2 mt-4'>
                                    {/*<div className={styles.giftHint} >*/}
                                    {/*    <img src={GiftBox} alt="gift" />*/}
                                    {/*    <p>PERFECT STOCKING FILLER</p>*/}
                                    {/*    <img src={GiftBox} alt="gift" />*/}
                                    {/*</div>*/}
                                    <div className={styles.gameInfoWrapper} style={this.getStoreInfoBackground()}>
                                        <div className={styles.strikeThroughPrice}><strong><span>{this.getStrikethroughPrice() || <DotLoader size="small" variant="dark" />}</span></strong></div>

                                        <p className={styles.gamePrice}>{this.getPrice() || <DotLoader size="medium" variant="dark" />}</p>
                                        <div className={styles.starRow}>
                                            {
                                                this.getGame()?.gamePackInfo.stars > 0 &&
                                                this.getStars()
                                            }
                                            <span className={styles.starSum} ></span>
                                        </div>
                                        {/*<br />*/}
                                        <button className={styles.button} onClick={() => this.addGameToCart(this.getGame())}>{this.state.loading ? <DotLoader size="medium" variant="dark" /> : "Add To Cart"}</button>
                                        <br />
                                        {/*<button className={`${styles.button} ${styles.medium} ${styles.alternate}`} onClick={() => this.setState({ showHowToPlay: true, }) }>What is Game.City?</button>*/}
                                        {/*<br />*/}
                                        <Link onClick={() => this.scrollIntoView("how-it-works")} className={styles.linkText}><strong>If you are unsure about how it <br /> works click here</strong></Link>

                                        <ul className={styles.gameInfo}>
                                            <li>
                                                <div className={styles.icon}>
                                                    <img src={time} />
                                                </div>
                                                <span>{this.getGame().gamePackInfo?.avgRoundLengthText}</span>
                                            </li>
                                            <li>
                                                <div className={styles.icon}>
                                                    <img src={players} />
                                                </div>
                                                <span>{this.getGame().gamePackInfo?.minPlayers}-{this.getGame().gamePackInfo?.maxPlayers ?? 8} Players</span>
                                            </li>
                                            <li>
                                                <div className={styles.icon}>
                                                    <img src={this.getAgeIcon()} />
                                                </div>
                                                <span>
                                                    Age {this.getGame().gamePackInfo?.minAge}+
                                                </span>
                                            </li>
                                        </ul>

                                        <hr></hr>

                                        <p className={`${styles.gameDescription} text-start`}><strong>{this.getGame().description}</strong></p>
                                        {
                                            <>
                                                <hr></hr>
                                                <p className={styles.header}>Supported Platforms</p>
                                                <div className={styles.platformsList}>
                                                    {this.getSupportedPlatforms()}
                                                </div>
                                            </>
                                        }
                                    </div>
                                    {/* Companion discount card — owner or buy-both */}
                                    {PricingFunctions.hasCrossRegionDiscount(this.getGame()) && (() => {
                                        const discount = PricingFunctions.getCrossRegionDiscount(this.getGame());
                                        const offer = PricingFunctions.getCompanionOffer(this.getGame());
                                        return (
                                            <div className={styles.companionOfferCard}>
                                                {offer?.companionStoreCard && (
                                                    <img src={offer.companionStoreCard} alt={discount.ownedPackName} className={styles.companionOfferImage} />
                                                )}
                                                <div className={styles.companionOfferText}>
                                                    <span className={styles.companionOfferTitle}>{discount.percent}% off — you own {discount.ownedPackName}</span>
                                                    <span className={styles.companionOfferSub}>Your discount is applied automatically at checkout</span>
                                                </div>
                                            </div>
                                        );
                                    })()}
                                    {PricingFunctions.shouldShowCompanionOffer(this.getGame()) && (() => {
                                        const offer = PricingFunctions.getCompanionOffer(this.getGame());
                                        return (
                                            <div className={styles.companionOfferCard}>
                                                {offer.companionStoreCard && (
                                                    <img src={offer.companionStoreCard} alt={offer.companionName} className={styles.companionOfferImage} />
                                                )}
                                                <div className={styles.companionOfferText}>
                                                    <span className={styles.companionOfferTitle}>Buy both &amp; save {offer.discountPercent}%</span>
                                                    <span className={styles.companionOfferSub}>Add <a href={offer.companionStoreSlug} className={styles.companionOfferLink} onClick={(e) => { e.preventDefault(); this.props.navigate(offer.companionStoreSlug); }}>{offer.companionName}</a> and get it discounted</span>
                                                </div>
                                                <button className={styles.companionOfferBtn} onClick={(e) => {
                                                    e.stopPropagation();
                                                    const companionGame = findGameBySlug(offer.companionStoreSlug);
                                                    if (companionGame) {
                                                        this.addGameToCart(this.getGame());
                                                        this.addGameToCart(companionGame);
                                                    }
                                                }}>Buy Both</button>
                                            </div>
                                        );
                                    })()}
                                </div>
                            </div>
                        </Container>
                    </section>
                    <header className={styles.smallBanner}>Works perfectly in all English speaking countries!</header>
                    <section className={`${styles.band} ${styles.sm}`} style={this.getStoreAccentBackground()}>
                    {/*<section className={`${styles.band} ${styles.cityBG}`}>*/}
                        <Container>
                            <div className={`row text-center justify-content-center`}>
                                <h2 className='text-uppercase'>About the games included</h2>
                                {
                                    this.getIncludedGames().map(g => <div className={`${styles.gameDetails} col-md-6 col-lg-4 text-center p-3`}>
                                        <div className={styles.gameDetailsInner}>
                                            <img className={styles.icon} src={g.meta?.storeTinyCard || placeHolderDesktop} alt={`${g.name}-info-icon`} />
                                            <p className={styles.description}>{this.newLineText(g.description)}</p>
                                            <div className={`row mt-1 p-4 ${styles.imageBlock}`}>
                                                <div style={{ backgroundImage: `url(${g.meta?.previewImages?.desktop1 || placeHolderDesktop})` }} className={`col-7 ${styles.img}`}>
                                                    <img src={g.meta?.previewImages?.desktop1 || placeHolderDesktop} alt={`${g.name}-preview-desktop-1`} />
                                                </div>
                                                <div style={{ backgroundImage: `url(${g.meta?.previewImages?.mobile1 || placeHolderMobile})` }} className={`col-3 ${styles.img}`}>
                                                    <img src={g.meta?.previewImages?.mobile1 || placeHolderMobile} alt={`${g.name}-preview-mobile-1`} />
                                                </div>
                                                <div style={{ backgroundImage: `url(${g.meta?.previewImages?.mobile2 || placeHolderMobile})` }} className={`col-3 ${styles.img}`}>
                                                    <img src={g.meta?.previewImages?.mobile2 || placeHolderMobile} alt={`${g.name}-preview-mobile-2`} />
                                                </div>
                                                <div style={{ backgroundImage: `url(${g.meta?.previewImages?.desktop2 || placeHolderDesktop})` }} className={`col-7 ${styles.img}`}>
                                                    <img src={g.meta?.previewImages?.desktop2 || placeHolderDesktop} alt={`${g.name}-preview-desktop-2`} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>)
                                }
                            </div>
                            <div className="row text-center my-5" id="how-it-works" >
                                <h2 className='text-uppercase mb-1'>Unsure about how it works?</h2>
                                <h4 className={`${styles.subTitle} text-uppercase`}>Playing a party game on your TV might sound like magic, but don't worry - it's as easy as 1-2-3.</h4>
                                <div className={`${styles.howItWorksBox} py-3`}>
                                    {
                                        howItWorksBlocks.map((x) => {
                                            return <div className={`${styles.howItWorksBlock} my-3`}>
                                                <div className={styles.number}>
                                                    <p>{x.number}</p>
                                                </div>
                                                <h3 className={styles.title}>{x.title}</h3>
                                                <p className={styles.description}>{x.description}</p>
                                            </div>
                                        })
                                    }
                                </div>
                            </div>
                            <div className='row text-center'>
                                <h2 className='text-uppercase'>buy them individually</h2>
                                {
                                    this.getIncludedGames().map(g => <div className='col-md-6 col-lg-4 text-center'><Game showAddToCart={true} game={g} key={g.gameId} /></div>)
                                }
                            </div>
                        </Container>
                    </section>
                    <section className={styles.reviewsSection}>
                        <div className="container">
                            <TrustBoxContainer
                                templateId={TRUSTPILOT_TEMPLATES.CAROUSEL}
                                height="240px"
                                width="100%"
                                theme="dark"
                                stars="5"
                            />
                        </div>
                    </section>
                </div>
                <Modal show={this.state.showHowToPlay} onHide={this.closeHelpModal} contentClassName={styles.rounded} centered dialogClassName="howToPlayModal" >
                    <CloseButton style={{ position: "absolute", zIndex: 2, top: "15px", left: "15px" }} onClick={this.closeHelpModal} />
                    <Modal.Body style={{ padding: "10px" }}>
                        <div className={styles.thumbnail}>
                        <img style={{ width: "100%", height: "100%" }} src={VideoThumbnail} />
                        </div>
                        <ReactPlayer url={this.getGame().meta.video} controls id='game-city-video' width={"100%"} height="auto" style={{ position:"relative", zIndex: 1,}}></ReactPlayer> 
                    </Modal.Body>
                </Modal>
            </React.Fragment>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        pricing: state.pricing
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        addToCart: (game) => {
            dispatch(addToCart(game))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ShopGamePack));
